import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import { NOTICE_TYPES } from '../../constants/noticeTypes';

const NoticeDisplay = () => {
  const [activeNotice, setActiveNotice] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const fetchActiveNotice = async () => {
      try {
        const noticesRef = collection(db, 'notices');
        const q = query(noticesRef, where('enabled', '==', true));
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          const notice = {
            id: querySnapshot.docs[0].id,
            ...querySnapshot.docs[0].data()
          };
          setActiveNotice(notice);
        } else {
          setActiveNotice(null);
        }
      } catch (error) {
        console.error('Error fetching active notice:', error);
      }
    };

    fetchActiveNotice();
    // Refresh every minute
    const interval = setInterval(fetchActiveNotice, 60000);
    return () => clearInterval(interval);
  }, []);

  if (!activeNotice || dismissed) return null;

  const typeStyles = NOTICE_TYPES[activeNotice.noticeType] || NOTICE_TYPES.GENERAL;

  // return (
  //   <div className="fixed bottom-8 right-8 z-50 w-full max-w-xl">
  //     <div 
  //       className={`rounded-xl shadow-lg border animate-fade-in ${typeStyles.bgColor} ${typeStyles.textColor} ${typeStyles.borderColor}`}
  //     >
  //       <div className="p-4">
  //         <div className="flex justify-between items-start">
  //           <h3 className="font-semibold text-lg">{activeNotice.title}</h3>
  //           <button 
  //             onClick={() => setDismissed(true)}
  //             className={`${typeStyles.iconColor} hover:opacity-75 text-2xl leading-none`}
  //           >
  //             ×
  //           </button>
  //         </div>
  //         <p className="mt-2">{activeNotice.content}</p>
  //         {activeNotice.imageURL && (
  //           <img 
  //             src={activeNotice.imageURL} 
  //             alt={activeNotice.title}
  //             className="mt-2 rounded-lg w-full h-auto"
  //           />
  //         )}
  //       </div>
  //     </div>
  //   </div>
  // );
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50 bg-gray-500 bg-opacity-50">
      <div 
        className={`rounded-xl shadow-lg border animate-fade-in ${typeStyles.bgColor} ${typeStyles.textColor} ${typeStyles.borderColor} max-w-md lg:max-w-xl w-full mx-4`}
      >
        <div className="p-4">
          <div className="flex justify-between items-start">
            <h3 className="font-semibold text-lg">{activeNotice.title}</h3>
            <button 
              onClick={() => setDismissed(true)}
              className={`${typeStyles.iconColor} hover:opacity-75 text-2xl leading-none`}
            >
              ×
            </button>
          </div>
          <p className="mt-2">{activeNotice.content}</p>
          {activeNotice.imageURL && (
            <img 
              src={activeNotice.imageURL} 
              alt={activeNotice.title}
              className="mt-2 rounded-lg w-full h-auto"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default NoticeDisplay; 